import { Button } from '@/components';
import { ButtonSize, ButtonVariant } from '@/interfaces';
import styled from 'styled-components';

export const EmailAccountsContainer = styled.div(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: theme.spacing[16],

  [`${theme.mediaBreakpointUp.lg}`]: {
    justifyContent: 'flex-start',
  },
}));

export const EmailAccountsList = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

export const AddEmailAccountButton = styled(Button).attrs({
  variant: ButtonVariant.Link,
  size: ButtonSize.Medium,
})(({ theme }) => ({
  display: 'flex',
  width: '100%',
  padding: `${theme.spacing[10]} 0`,

  '> span': {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing[4],
  },
}));

export const LoadingWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  color: theme.colors.blue,
  flex: 1,
  margin: 'auto',

  '> div': {
    justifyContent: 'center',
  },
}));
